<script>
export default {
  props: {
    id: { type: String, required: true, default: '' }, //表格ID
    data: { type: Array, required: true, default: () => [] }, //数据源
    columns: { type: Array, required: true, default: () => [] }, //列定义
    tree: { type: Boolean, default: false }, //是否是树形
    expandAll: { type: Boolean, default: false }, //是否全部展开
    page: { type: Object, default: () => null }, //分页对象
    loading: { type: Boolean, default: false }, //加载中
    toolbar: { type: Boolean, default: true },
    rowField: { type: String, default: 'id' },
    scroll: { type: Boolean, default: true },
    minHeight: { type: String, default: '' }
  },

  data() {
    return {
      elementui_page_component_key: 1
    }
  },

  watch: {
    page: {
      deep: true,
      handler() {
        this.elementui_page_component_key++
      }
    }
  },

  computed: {
    //获取自定义插槽
    slots() {
      const keys = Object.keys(this.$scopedSlots || {})
      return keys.filter(item => item && item !== 'toolbar' && item.indexOf('$') === -1)
    },

    //树形配置
    treeConfig() {
      if(this.tree) {
        return {
          //transform: true,
          rowField: this.rowField || 'id',
          parentField: 'parentId',
          childrenField: 'children',
          hasChild: 'hasChild',
          indent: 20,
          expandAll: this.expandAll,
          reserve: true,
          showIcon: true
        }
      }

      return undefined
    }
  },

  methods: {
    //每页大小改变事件
    onSizeChange(size) {
      this.$emit('size-change', size)
    },

    //当前页改变事件
    onCurrentChange(current) {
      this.$emit('current-change', current)
    },

    //展开/收起树形
    expand(open) {
      if(open) {
        this.$refs.gridRef.setAllTreeExpand(true)
      } else {
        this.$refs.gridRef.clearTreeExpand()
      }
    },

    //刷新按钮事件
    refresh() {
      this.$emit('refresh')
    },

    //清除选中行
    clearCurrentRow() {
      if(this.$refs.gridRef) this.$refs.gridRef.clearCurrentRow()
    },

    //设置高亮行
    setCurrentRow(row) {
      if(this.$refs.gridRef) this.$refs.gridRef.setCurrentRow(row)
    },

    //行点击事件
    onCellClick({ row }) {
      this.$emit('cell-click', row)
    },

    //行双击事件
    onCellDBClick({ row }) {
      this.$emit('cell-dblclick', row)
    },

    //选中行切换事件
    onGridCurrentChange({ row }) {
      this.$emit('row-change', row)
    },

    //获取选中数据
    getCheck() {
      if(this.$refs.gridRef) {
        return this.$refs.gridRef.getCheckboxRecords(true)
      } else {
        return []
      }
    },

    //设置选中
    setCheck(rows) {
      if(this.$refs.gridRef) {
        this.$refs.gridRef.setCheckboxRow(rows, true)
      }
    },

    //重新计算表格，如果传 true 则进行完整计算
    recalculate(refull) {
      if(this.$refs.gridRef) {
        this.$refs.gridRef.recalculate(refull)
      }
    },

    //获取光标
    focus() {
      if(this.$refs.gridRef) {
        this.$refs.gridRef.focus()
      }
    },

    //获取选中行
    getCurrentRecord() {
      if(this.$refs.gridRef) {
        return this.$refs.gridRef.getCurrentRecord()
      }

      return null
    },

    //获取全部数据
    getFullData() {
      if(this.$refs.gridRef) {
        return this.$refs.gridRef.getTableData().fullData || []
      }

      return []
    }
  }
}
</script>

<template>
  <div class="table">
    <vxe-grid
      ref="gridRef"
      resizable
      size="small"
      :height="scroll ? 'auto': undefined"
      :minHeight="minHeight"
      :id="id"
      :data="data"
      :columns="columns"
      :loading="loading"
      :seq-config="{ startIndex: page ? ((page.current || 1) - 1) * (page.size || 0) : 0 }"
      :show-overflow="true"
      :show-header-overflow="true"
      :show-footer-overflow="true"
      :autoResize="true"
      :border="true"
      :round="false"
      :tooltip-config="{ enterable: true }"
      :custom-config="{ storage: true }"
      :toolbar-config="toolbar ? { custom: { immediate: true, isFooter: false, allowFixed: true, icon: 'el-icon-setting' }, slots: { buttons: 'toolbar_buttons', tools: 'toolbar_tools' } } : undefined"
      :tree-config="treeConfig"
      :row-config="{ isCurrent: true, isHover: true }"
      :keyboard-config="{isArrow: true}"
      :scroll-y="{ enabled: scroll, gt: 500 }"
      @cell-click="onCellClick"
      @cell-dblclick="onCellDBClick"
      @current-change="onGridCurrentChange"
    >
      <!--工具插槽-->
      <template #toolbar_buttons>
        <slot name="toolbar"></slot>
      </template>

      <template #toolbar_tools>
        <slot name="toolaction"></slot>
        <vxe-button icon="vxe-icon-refresh" circle :title="$t('table.refresh')" @click="refresh"></vxe-button>
      </template>

      <!--自定义插槽-->
      <template v-for="item in slots" #[item]="{ row, rowIndex, column, columnIndex }">
        <slot :name="item" :row="row" :row-index="rowIndex" :column="column" :column-index="columnIndex"></slot>
      </template>

      <template #pager>
        <div v-if="page" class="table-page">
          <el-pagination :key="elementui_page_component_key" :current-page="page.current" :page-size="page.size" :total="page.total" :page-sizes="[10, 20, 50, 100, 200, 300, 500]" layout="total, sizes, prev, pager, next, jumper" @size-change="onSizeChange" @current-change="onCurrentChange"></el-pagination>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<style lang="scss">
.table{
  width: 100%;
  height: 100%;
  position: relative;

  .vxe-grid{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    .vxe-grid--toolbar-wrapper{

      .vxe-toolbar{
        padding-top: 0;

        .vxe-custom--footer{
          display: flex;
        }
      }
    }

    &.no-toolbar{
      .vxe-grid--toolbar-wrapper{
        position: absolute;
        top: 8px;
        right: 6px;
        z-index: 3;

        .vxe-toolbar{
          padding: 0;
          background-color: transparent;
        }
      }
    }

    .vxe-toolbar .vxe-tools--operate{
      margin-left: 5px;
    }
  }

  &-page{
    padding-top: 10px;
    text-align: right;
  }
}
</style>
